// Constants
import { DueDateCategory } from "@ms/uno-constants/lib/local/DateConstants";
import { FilterTypes } from "../constants/FilterConstants";
// Utilities
import * as StringHelper from "@fluentui/utilities";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Get the title for a date category filter value
 * @param filterValue Filter value to map to a title
 */ export function getDateFilterTitle(filterValue) {
    switch(filterValue){
        case DueDateCategory.NoDate:
            return Strings.TaskFiltering_NoDateDueDateText;
        case DueDateCategory.Late:
            return Strings.TaskFiltering_PastDueDateText;
        case DueDateCategory.Today:
            return Strings.TaskFiltering_TodayDueDateText;
        case DueDateCategory.Tomorrow:
            return Strings.TaskFiltering_TomorrowDueDateText;
        case DueDateCategory.ThisWeek:
            return Strings.TaskFiltering_ThisWeekDueDateText;
        case DueDateCategory.NextWeek:
            return Strings.TaskFiltering_NextWeekDueDateText;
        case DueDateCategory.Future:
            return Strings.TaskFiltering_FutureDueDateText;
        case DueDateCategory.SomeDate:
            return Strings.TaskFiltering_SomeDueDateText;
        default:
            throw new Error(`FilterUtilities.getDateFilterTitle - Unexpected DueDateCategory [Value=${filterValue}]`);
    }
}
/**
 * Get the aria label for the filter title
 * @param filterType Filter type to get aria label for
 */ export function getFilterTitleAriaLabel(filterType) {
    switch(filterType){
        case FilterTypes.FinishDateTime:
            return Strings.TaskFiltering_DueDateFilterSectionName;
        case FilterTypes.Priority:
            return Strings.TaskFiltering_PriorityFilterSectionName;
        case FilterTypes.Status:
            return Strings.TaskFiltering_ProgressFilterSectionName;
        case FilterTypes.AppliedCategoryIds:
            return Strings.TaskFiltering_LabelFilterSectionName;
        case FilterTypes.BucketId:
            return Strings.TaskFiltering_BucketFilterSectionName;
        case FilterTypes.UserAssignments:
            return Strings.TaskFiltering_AssignmentFilterSectionName;
        default:
            throw new Error(`FilterUtilities.getFilterTitleAriaLabel - Unexpected FilterTypes [Value=${filterType}]`);
    }
}
/**
 * Get the aria label for the filter title section
 * @param filterType Filter type to get aria label for
 * @param filterField Filter field key in ITask
 * @param taskFilter ITask EntityFilter
 */ export function getFilterTitleSectionAriaLabel(filterType, filterField, taskFilter) {
    return StringHelper.format(Strings.TaskFiltering_ToggleFilterSectionAriaLabel, getFilterTitleAriaLabel(filterType), getAppliedFilterCount(filterField, taskFilter));
}
/**
 * Gets the number of filters applied in the filter section
 * @param filterField Filter field key in ITask
 * @param taskFilter ITask EntityFilter
 */ export function getAppliedFilterCount(filterField, taskFilter) {
    return taskFilter.getFieldFilterCount(filterField);
}
/**
 * Gets the display text for the filter menu items
 * @param itemName Filter menu item name
 * @param filterField Filter field key in ITask
 * @param taskFilter ITask EntityFilter
 */ export function getFilterMenuItemDisplayText(itemName, filterField, taskFilter) {
    let displayText = itemName;
    const filterCount = getAppliedFilterCount(filterField, taskFilter);
    if (filterCount > 0) {
        displayText = displayText.concat(" (", filterCount.toString(), ")");
    }
    return displayText;
}
/**
 * Gets the filter input string for the plan filter
 * @param filter IPlansListItem EntityFilter
 */ export function getPlanFilterInputString(filter) {
    const currentInput = filter?.filters?.find((filter)=>filter.field === "name")?.values?.[0] ?? "";
    return currentInput;
}
/**
 * Keys a filter by what each active clause selects, sorted so neither clause order nor value order
 * changes the key. Inactive clauses are skipped since they do not change what is shown.
 * @example getTaskFilterKey(byAssigneeAndPriority) === "assignedTo=user-1|user-2,priority=urgent"
 * @param filter The filter, or null when cleared
 */ export function getTaskFilterKey(filter) {
    return (filter?.filters ?? []).filter((clause)=>clause.active).map((clause)=>`${clause.field}=${clause.values.map(String).sort().join("|")}`).sort().join(",");
}
